import { render, staticRenderFns } from "./PreOrderStatus.vue?vue&type=template&id=6b96af69&scoped=true&"
import script from "./PreOrderStatus.vue?vue&type=script&lang=js&"
export * from "./PreOrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96af69",
  null
  
)

export default component.exports